import React, { FC, useState } from "react";
import { useIntl } from "react-intl";

import GeneralFeedbackModal from "../../GeneralFeedbackModal";
import { buttonCss } from "../BugReportModal/styles";
import useSubmitMessage from "./useSubmitMessage";
import { PurposedButtonProps } from "../../../../../atoms/inputs/EwaButtons/types";
import { useFileStorage } from "../../../../../atoms/inputs/FlowioFileDropzone/utils";

type Props = {
  isOpen: boolean;
  toggleOpen: () => void;
};

const Container: FC<Props> = ({ isOpen, toggleOpen }) => {
  const [message, setMessage] = useState("");

  const { formatMessage: fm } = useIntl();

  const placeholder = fm({ id: "feedback.feedback.message_here" });
  const buttonLabel = fm({ id: "common.send" });
  const modalTitle = fm({ id: "feedback.feedback.send_feedback" });

  const buttonProps: PurposedButtonProps = {
    css: buttonCss,
    label: buttonLabel,
    iconName: "send",
  };

  const flowioInputProps = { placeholder };

  const { files, addFiles, deleteFile } = useFileStorage({ maxFiles: 5 });
  const [submitMessage, isSubmitting] = useSubmitMessage(message, files);

  const handleSubmit = async () => {
    await submitMessage();
    toggleOpen();
  };

  return (
    <GeneralFeedbackModal
      isOpen={isOpen}
      files={files}
      onFileDelete={deleteFile}
      onAddFiles={addFiles}
      toggle={toggleOpen}
      modalTitle={modalTitle}
      isSubmitting={isSubmitting}
      message={message}
      changeMessage={setMessage}
      onSubmit={handleSubmit}
      buttonProps={buttonProps}
      flowioInputProps={flowioInputProps}
    />
  );
};

export default Container;
export type FeedbackModalProps = Props;
